import request from './request'

export function pageItems(params) {
  return request({ url: '/api/items', method: 'get', params })
}

export function getItem(id) {
  return request({ url: `/api/items/${id}`, method: 'get' })
}

export function createItem(data) {
  return request({ url: '/api/items', method: 'post', data })
}

export function updateItem(id, data) {
  return request({ url: `/api/items/${id}`, method: 'put', data })
}

export function deleteItem(id) {
  return request({ url: `/api/items/${id}`, method: 'delete' })
}

export function sellItem(id, data) {
  return request({ url: `/api/items/${id}/sell`, method: 'patch', data })
}

export function unsellItem(id) {
  return request({ url: `/api/items/${id}/unsell`, method: 'patch' })
}

export function exportItems(params) {
  return request({ url: '/api/items/export', method: 'get', params, responseType: 'blob' })
}
